import { InputWrapper } from '~/@/components/inputs/base/input-wrapper'
import { BaseInputProps } from '~/@/components/inputs/base/types'
import { Checkbox, CheckboxProps } from '~/@/components/inputs/standalone/checkbox'
import { cn } from '~/@/lib/utils'

type CheckboxGroupOption = {
  value: string
  checked: CheckboxProps['checked']
  onCheckedChange: CheckboxProps['onCheckedChange']
  label?: string
  disabled?: CheckboxProps['disabled']
}

export type CheckboxGroupProps = BaseInputProps & {
  options: CheckboxGroupOption[]
  className?: string
}

export const CheckboxGroup = (props: CheckboxGroupProps) => {
  const {
    className,
    options,
    wrapperClassName,
    errorText,
    helperText,
    label,
    required,
    showDirtyIndicator,
    tooltip,
  } = props

  return (
    <InputWrapper
      wrapperClassName={wrapperClassName}
      errorText={errorText}
      helperText={helperText}
      label={label}
      required={required}
      showDirtyIndicator={showDirtyIndicator}
      tooltip={tooltip}
    >
      {options.map((option) => (
        <Checkbox
          className={cn('p-0', className)}
          key={option.value}
          checked={option.checked}
          disabled={option.disabled}
          label={option.label}
          onCheckedChange={option.onCheckedChange}
        />
      ))}
    </InputWrapper>
  )
}
